// extracted by mini-css-extract-plugin
module.exports = {"register":"Register_register__WPX9C"};